/* ============================================================
   MA Press Marquee
   - rAF-driven infinite scroll
   - Clones enough sets to always fill 2× viewport (no gap)
   - Pauses on hover (configurable)
   ============================================================ */

(function () {
  'use strict';

  class PressMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ma-press-marquee__track');
      if (!this.track) return;

      this.originalItems = Array.from(this.track.querySelectorAll('.ma-press-marquee__item'));
      if (this.originalItems.length === 0) return;

      this.speed        = parseFloat(this.dataset.speed) || 60;
      this.pauseOnHover = this.dataset.pauseOnHover !== 'false';
      this.marqueePos   = 0;
      this.paused       = false;
      this.lastTs       = null;
      this.loopWidth    = 0;

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => { this.paused = true; });
        this.addEventListener('mouseleave', () => { this.paused = false; });
      }

      // Defer until after first paint so images have reserved their dimensions
      requestAnimationFrame(() => this._setup());
    }

    disconnectedCallback() {
      if (this.rafId) cancelAnimationFrame(this.rafId);
    }

    _setup() {
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.loopWidth = this.originalItems.reduce((sum, item) => sum + item.offsetWidth + gap, 0);

      if (this.loopWidth === 0) {
        // Items not laid out yet — retry next frame
        requestAnimationFrame(() => this._setup());
        return;
      }

      // Clone until the track is wide enough to always fill 2× viewport with
      // no gap visible at the reset point (need: filled >= 2 * vw + loopWidth)
      const needed = window.innerWidth * 2 + this.loopWidth;
      let filled = this.loopWidth;
      while (filled < needed) {
        this.originalItems.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          this.track.appendChild(clone);
        });
        filled += this.loopWidth;
      }

      this.rafId = requestAnimationFrame((ts) => this.tick(ts));
    }

    tick(ts) {
      if (this.lastTs !== null && !this.paused) {
        const delta = ts - this.lastTs;
        this.marqueePos += (this.speed * delta) / 1000;

        if (this.marqueePos >= this.loopWidth) {
          this.marqueePos -= this.loopWidth;
        }

        this.track.style.transform = `translateX(${-this.marqueePos}px)`;
      }

      this.lastTs = ts;
      this.rafId  = requestAnimationFrame((ts) => this.tick(ts));
    }
  }

  customElements.define('press-marquee', PressMarquee);
})();
